
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store-accessor";

@Component({
  components: {}
})
export default class StandardButton extends Vue {
  @Prop({
    default: false
  })
  loading!: boolean;
  @Prop({
    default: false
  })
  active!: boolean;
  @Prop({
    default: "auto"
  })
  minWidth!: number | "auto";

  @Prop()
  testId!: string;

  get classList() {
    return {
      "breakdance-toolbar-button": this.builderMode === "breakdance",
      "breakdance-toolbar-button--active": this.active,
      "button-oxygen": this.builderMode === "oxygen"
    };
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
